module.exports = __webpack_public_path__ + "img/mastercard.f6ad4722.svg";